import ServiceBase from "./ServiceBase"

const resource = "/productpackages"

export default
	{
		getProductPackages()
		{
			return ServiceBase.get(resource)
		},
		getProductPackage(id)
		{
			return ServiceBase.get(resource + "/" + id)
		},
		updateProductPackage(payload)
		{
			return ServiceBase.put(resource + "/" + payload.id, payload)
		},
		addProductPackage(payload)
		{
			return ServiceBase.post(resource, payload)
		},
		deleteProductPackage(id)
		{
			return ServiceBase.delete(resource + "/" + id)
		}
	}